import React from 'react';
import { Modal } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

export const onError = (error) => {
  if (error?.responseJSON?.message) {
    Modal.error({
      content: error?.responseJSON?.message,
    });
  } else {
    Modal.error({
      content: getTranslatedString('unknownError'),
    });
  }
};
